import React from 'react';

// Boxy - The Happy Package (use: package received)
export const Boxy = ({ size = 120, animate = false }) => (
  <svg viewBox="0 0 200 200" width={size} height={size} style={{ display: 'block', margin: '0 auto' }}>
    <rect x="40" y="60" width="120" height="100" rx="8" fill="#D2691E" stroke="#8B4513" strokeWidth="3"/>
    <line x1="100" y1="60" x2="100" y2="160" stroke="#8B4513" strokeWidth="2" strokeDasharray="5,5"/>
    <line x1="40" y1="110" x2="160" y2="110" stroke="#8B4513" strokeWidth="2" strokeDasharray="5,5"/>
    <rect x="80" y="50" width="40" height="20" rx="3" fill="#F4D03F" opacity="0.9"/>
    <circle cx="80" cy="90" r="12" fill="white"/>
    <circle cx="120" cy="90" r="12" fill="white"/>
    <circle cx="83" cy="90" r="6" fill="#333">
      <animate attributeName="cx" values="83;86;83;80;83" dur="3s" repeatCount="indefinite"/>
    </circle>
    <circle cx="123" cy="90" r="6" fill="#333">
      <animate attributeName="cx" values="123;126;123;120;123" dur="3s" repeatCount="indefinite"/>
    </circle>
    <path d="M 80 125 Q 100 145 120 125" fill="none" stroke="#333" strokeWidth="3" strokeLinecap="round">
      <animate attributeName="d" values="M 80 125 Q 100 145 120 125;M 80 128 Q 100 150 120 128;M 80 125 Q 100 145 120 125" dur="2s" repeatCount="indefinite"/>
    </path>
    <circle cx="68" cy="120" r="8" fill="#FFB6C1" opacity="0.5"/>
    <circle cx="132" cy="120" r="8" fill="#FFB6C1" opacity="0.5"/>
    <g style={{ transformOrigin: '40px 100px', animation: animate ? 'cartoonWaveL 0.5s ease 3' : 'none' }}>
      <path d="M 40 100 Q 20 80 15 95" fill="none" stroke="#D2691E" strokeWidth="6" strokeLinecap="round"/>
      <circle cx="15" cy="95" r="6" fill="#F4D03F"/>
    </g>
    <g style={{ transformOrigin: '160px 100px', animation: animate ? 'cartoonWaveR 0.5s ease 3' : 'none' }}>
      <path d="M 160 100 Q 180 80 185 95" fill="none" stroke="#D2691E" strokeWidth="6" strokeLinecap="round"/>
      <circle cx="185" cy="95" r="6" fill="#F4D03F"/>
    </g>
    <rect x="70" y="158" width="16" height="25" rx="8" fill="#8B4513">
      <animate attributeName="height" values="25;20;25" dur="1s" repeatCount="indefinite"/>
    </rect>
    <rect x="114" y="158" width="16" height="25" rx="8" fill="#8B4513">
      <animate attributeName="height" values="25;20;25" dur="1s" begin="0.5s" repeatCount="indefinite"/>
    </rect>
  </svg>
);

// Speedy - The Delivery Runner (use: loading/delivery)
export const Speedy = ({ size = 120 }) => (
  <svg viewBox="0 0 200 200" width={size} height={size} style={{ display: 'block', margin: '0 auto' }}>
    <ellipse cx="100" cy="130" rx="30" ry="35" fill="#4ECDC4"/>
    <circle cx="100" cy="70" r="30" fill="#FFE0BD"/>
    <path d="M 70 65 Q 100 30 130 65" fill="#E74C3C"/>
    <rect x="65" y="62" width="70" height="8" rx="4" fill="#C0392B"/>
    <circle cx="100" cy="42" r="5" fill="#E74C3C"/>
    <circle cx="88" cy="68" r="8" fill="white"/>
    <circle cx="112" cy="68" r="8" fill="white"/>
    <circle cx="90" cy="68" r="4" fill="#333">
      <animate attributeName="cx" values="90;93;90" dur="0.3s" repeatCount="indefinite"/>
    </circle>
    <circle cx="114" cy="68" r="4" fill="#333">
      <animate attributeName="cx" values="114;117;114" dur="0.3s" repeatCount="indefinite"/>
    </circle>
    <path d="M 90 85 L 110 85" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
    <ellipse cx="135" cy="60" rx="4" ry="6" fill="#87CEEB" opacity="0.8">
      <animate attributeName="cy" values="55;65;55" dur="1s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="0.8;0;0.8" dur="1s" repeatCount="indefinite"/>
    </ellipse>
    <line x1="85" y1="162" x2="60" y2="185" stroke="#FFE0BD" strokeWidth="8" strokeLinecap="round">
      <animate attributeName="x2" values="60;75;60" dur="0.4s" repeatCount="indefinite"/>
    </line>
    <line x1="115" y1="162" x2="140" y2="185" stroke="#FFE0BD" strokeWidth="8" strokeLinecap="round">
      <animate attributeName="x2" values="140;125;140" dur="0.4s" repeatCount="indefinite"/>
    </line>
    <line x1="75" y1="120" x2="50" y2="100" stroke="#FFE0BD" strokeWidth="6" strokeLinecap="round">
      <animate attributeName="x2" values="50;45;50" dur="0.4s" repeatCount="indefinite"/>
    </line>
    <rect x="35" y="88" width="20" height="16" rx="3" fill="#D2691E" stroke="#8B4513" strokeWidth="1.5">
      <animate attributeName="y" values="88;85;88" dur="0.4s" repeatCount="indefinite"/>
    </rect>
    {[120, 130, 140].map((y, i) => (
      <line key={i} x1="30" y1={y} x2={10 + i * 5} y2={y} stroke="#999" strokeWidth="2" opacity="0.4">
        <animate attributeName="opacity" values="0.4;0;0.4" dur="0.3s" begin={`${i * 0.1}s`} repeatCount="indefinite"/>
      </line>
    ))}
  </svg>
);

// Stella - The Star Rater (use: rating screen)
export const Stella = ({ size = 120 }) => (
  <svg viewBox="0 0 200 200" width={size} height={size} style={{ display: 'block', margin: '0 auto' }}>
    <polygon points="100,20 120,75 180,80 135,115 150,175 100,145 50,175 65,115 20,80 80,75"
      fill="#FFD700" stroke="#FFA500" strokeWidth="2">
      <animate attributeName="points"
        values="100,20 120,75 180,80 135,115 150,175 100,145 50,175 65,115 20,80 80,75;100,25 118,77 175,82 133,117 148,173 100,148 52,173 67,117 25,82 82,77;100,20 120,75 180,80 135,115 150,175 100,145 50,175 65,115 20,80 80,75"
        dur="3s" repeatCount="indefinite"/>
    </polygon>
    <circle cx="85" cy="85" r="8" fill="white"/>
    <circle cx="115" cy="85" r="8" fill="white"/>
    <circle cx="87" cy="85" r="4" fill="#333">
      <animate attributeName="r" values="4;1;4" dur="3s" repeatCount="indefinite"/>
    </circle>
    <circle cx="117" cy="85" r="4" fill="#333">
      <animate attributeName="r" values="4;1;4" dur="3s" repeatCount="indefinite"/>
    </circle>
    <line x1="78" y1="78" x2="75" y2="72" stroke="#333" strokeWidth="1.5"/>
    <line x1="82" y1="76" x2="80" y2="70" stroke="#333" strokeWidth="1.5"/>
    <line x1="118" y1="76" x2="120" y2="70" stroke="#333" strokeWidth="1.5"/>
    <line x1="122" y1="78" x2="125" y2="72" stroke="#333" strokeWidth="1.5"/>
    <path d="M 85 105 Q 100 125 115 105" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="72" cy="100" r="7" fill="#FFB6C1" opacity="0.6"/>
    <circle cx="128" cy="100" r="7" fill="#FFB6C1" opacity="0.6"/>
  </svg>
);

// Scannie - The Smart Scanner (use: OCR scanning)
export const Scannie = ({ size = 120 }) => (
  <svg viewBox="0 0 200 200" width={size} height={size} style={{ display: 'block', margin: '0 auto' }}>
    <rect x="55" y="30" width="90" height="150" rx="14" fill="#333" stroke="#555" strokeWidth="2"/>
    <rect x="62" y="45" width="76" height="110" rx="4" fill="#87CEEB"/>
    <rect x="62" y="80" width="76" height="3" fill="#FF0000" opacity="0.8">
      <animate attributeName="y" values="45;150;45" dur="2s" repeatCount="indefinite"/>
    </rect>
    <circle cx="85" cy="90" r="7" fill="white"/>
    <circle cx="115" cy="90" r="7" fill="white"/>
    <circle cx="87" cy="90" r="3.5" fill="#333"/>
    <circle cx="117" cy="90" r="3.5" fill="#333"/>
    <path d="M 88 110 Q 100 122 112 110" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="100" cy="38" r="5" fill="#555"/>
    <circle cx="100" cy="38" r="3" fill="#333"/>
    <circle cx="101" cy="37" r="1" fill="white"/>
    <path d="M 55 100 Q 30 85 25 100" fill="none" stroke="#333" strokeWidth="5" strokeLinecap="round">
      <animate attributeName="d" values="M 55 100 Q 30 85 25 100;M 55 100 Q 30 75 20 85;M 55 100 Q 30 85 25 100" dur="2s" repeatCount="indefinite"/>
    </path>
    <path d="M 145 100 Q 170 85 175 100" fill="none" stroke="#333" strokeWidth="5" strokeLinecap="round">
      <animate attributeName="d" values="M 145 100 Q 170 85 175 100;M 145 100 Q 170 75 180 85;M 145 100 Q 170 85 175 100" dur="2s" begin="0.3s" repeatCount="indefinite"/>
    </path>
    <ellipse cx="82" cy="182" rx="12" ry="6" fill="#555"/>
    <ellipse cx="118" cy="182" rx="12" ry="6" fill="#555"/>
    {[0,1,2,3,4,5,6].map(i => (
      <rect key={i} x={70 + i*8} y="120" width={i%2===0 ? 4 : 2} height="20" fill="#333" opacity="0.6"/>
    ))}
  </svg>
);

// Checky - The Pickup Confirmer (use: pickup confirmed)
export const Checky = ({ size = 120 }) => (
  <svg viewBox="0 0 200 200" width={size} height={size} style={{ display: 'block', margin: '0 auto' }}>
    <circle cx="100" cy="100" r="60" fill="#27AE60" stroke="#1E8449" strokeWidth="3"/>
    <path d="M 65 100 L 90 125 L 140 70" fill="none" stroke="white" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="80" cy="88" r="7" fill="white"/>
    <circle cx="105" cy="78" r="7" fill="white"/>
    <circle cx="82" cy="88" r="3.5" fill="#333">
      <animate attributeName="cy" values="88;86;88" dur="2s" repeatCount="indefinite"/>
    </circle>
    <circle cx="107" cy="78" r="3.5" fill="#333">
      <animate attributeName="cy" values="78;76;78" dur="2s" repeatCount="indefinite"/>
    </circle>
    <path d="M 92 102 Q 98 112 108 98" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <path d="M 45 80 Q 25 65 20 80" fill="none" stroke="#27AE60" strokeWidth="5" strokeLinecap="round">
      <animate attributeName="d" values="M 45 80 Q 25 65 20 80;M 45 80 Q 20 50 15 60;M 45 80 Q 25 65 20 80" dur="1.5s" repeatCount="indefinite"/>
    </path>
    <path d="M 155 80 Q 175 65 180 80" fill="none" stroke="#27AE60" strokeWidth="5" strokeLinecap="round">
      <animate attributeName="d" values="M 155 80 Q 175 65 180 80;M 155 80 Q 180 50 185 60;M 155 80 Q 175 65 180 80" dur="1.5s" begin="0.3s" repeatCount="indefinite"/>
    </path>
    <ellipse cx="85" cy="163" rx="10" ry="5" fill="#1E8449"/>
    <ellipse cx="115" cy="163" rx="10" ry="5" fill="#1E8449"/>
  </svg>
);

// Noti - The Alert Bell (use: notifications)
export const Noti = ({ size = 120 }) => (
  <svg viewBox="0 0 200 200" width={size} height={size} style={{ display: 'block', margin: '0 auto' }}>
    <g>
      <path d="M 60 120 Q 60 50 100 40 Q 140 50 140 120 L 155 130 Q 158 138 150 140 L 50 140 Q 42 138 45 130 Z"
        fill="#F39C12" stroke="#E67E22" strokeWidth="2">
        <animateTransform attributeName="transform" type="rotate"
          values="0 100 40;5 100 40;-5 100 40;3 100 40;-3 100 40;0 100 40"
          dur="2s" repeatCount="indefinite"/>
      </path>
    </g>
    <circle cx="100" cy="150" r="10" fill="#E67E22"/>
    <circle cx="100" cy="35" r="6" fill="#E67E22"/>
    <circle cx="82" cy="95" r="8" fill="white"/>
    <circle cx="118" cy="95" r="8" fill="white"/>
    <circle cx="84" cy="95" r="4" fill="#333"/>
    <circle cx="120" cy="95" r="4" fill="#333"/>
    <path d="M 88 115 Q 100 128 112 115" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="70" cy="108" r="6" fill="#FFB6C1" opacity="0.5"/>
    <circle cx="130" cy="108" r="6" fill="#FFB6C1" opacity="0.5"/>
    <path d="M 160 90 Q 175 100 160 110" fill="none" stroke="#F39C12" strokeWidth="2" opacity="0.6">
      <animate attributeName="opacity" values="0.6;0;0.6" dur="1s" repeatCount="indefinite"/>
    </path>
    <path d="M 170 80 Q 190 100 170 120" fill="none" stroke="#F39C12" strokeWidth="2" opacity="0.4">
      <animate attributeName="opacity" values="0.4;0;0.4" dur="1s" begin="0.3s" repeatCount="indefinite"/>
    </path>
    <path d="M 40 90 Q 25 100 40 110" fill="none" stroke="#F39C12" strokeWidth="2" opacity="0.6">
      <animate attributeName="opacity" values="0.6;0;0.6" dur="1s" begin="0.15s" repeatCount="indefinite"/>
    </path>
  </svg>
);

// Cartoon animation keyframes - inject once
export const CartoonStyles = () => (
  <style>{`
    @keyframes cartoonWaveL {
      0%, 100% { transform: rotate(0deg); }
      50% { transform: rotate(-30deg); }
    }
    @keyframes cartoonWaveR {
      0%, 100% { transform: rotate(0deg); }
      50% { transform: rotate(30deg); }
    }
    @keyframes cartoonBounce {
      0%, 100% { transform: translateY(0) scale(1); }
      30% { transform: translateY(-20px) scale(1.05); }
      50% { transform: translateY(0) scale(0.95); }
      70% { transform: translateY(-8px) scale(1.02); }
    }
    @keyframes cartoonPop {
      0% { transform: scale(0); opacity: 0; }
      50% { transform: scale(1.2); }
      70% { transform: scale(0.9); }
      100% { transform: scale(1); opacity: 1; }
    }
  `}</style>
);
